import { render, staticRenderFns } from "./system-message.vue?vue&type=template&id=0eda1ce9&scoped=true&"
import script from "./system-message.js?vue&type=script&lang=js&"
export * from "./system-message.js?vue&type=script&lang=js&"
import style0 from "./system-message.scss?vue&type=style&index=0&id=0eda1ce9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eda1ce9",
  null
  
)

export default component.exports